<template>
  <input @keydown="handleKeyDown" v-model="internalValue" />
</template>

<script>
const regExp = new RegExp('^[0-9-+ ()]+$')
const systemKeys = [
  'Tab',
  'Meta',
  'Enter',
  'Escape',
  'Backspace',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Shift',
  'Control'
]

export default {
  props: ['value'],
  data () {
    return {
      internalValue: this.value
    }
  },
  methods: {
    handleKeyDown (e) {
      const key = e.key

      if (systemKeys.includes(key)) {
        return
      }

      if (regExp.test(key) === false) {
        e.preventDefault()
      }
    }
  },
  watch: {
    internalValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>
